import { render, staticRenderFns } from "./task_step_select_recipient.vue?vue&type=template&id=1b889dd8&scoped=true"
import script from "./task_step_select_recipient.vue?vue&type=script&lang=js"
export * from "./task_step_select_recipient.vue?vue&type=script&lang=js"
import style0 from "./task_step_select_recipient.vue?vue&type=style&index=0&id=1b889dd8&prod&scoped=true&lang=css"
import style1 from "./task_step_select_recipient.vue?vue&type=style&index=1&id=1b889dd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b889dd8",
  null
  
)

export default component.exports